import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const addBudgetGroupHandler = async (props) => {
  const { group, budgetLastUpdated, budgetId } = props;

  const response = await BudgetAPI.postWOP(`${budgetId}/$addgroup`, {
    name: group?.label,
    lastUpdated: budgetLastUpdated,
  });
  return response.data;
};

export default addBudgetGroupHandler;
